import { StrictMode } from 'react'
import { hydrateRoot, createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

const rootEl = document.getElementById('root')

// Every route is prerendered now (see scripts/prerender.js), so the server
// HTML is always real — hydrateRoot attaches React to it instead of
// discarding and remounting from scratch. That distinction matters
// visually, not just for crawlers: createRoot() here would blank the page
// and replay every entrance animation on load, even for a normal visitor
// on a fast connection who never needed a re-render at all.
//
// The only route without static content is truly-unknown paths (Netlify's
// SPA fallback serves the plain index.html shell for those) — falling
// back to createRoot for that specific case so the 404 page still works.
if (rootEl.hasChildNodes()) {
  hydrateRoot(
    rootEl,
    <StrictMode>
      <App />
    </StrictMode>,
  )
} else {
  createRoot(rootEl).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}
